module.exports = __webpack_public_path__ + "Employer Notice 7_31_2024.pdf";